import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {RoomSetting} from '../models/room-setting';
import {AllEventsSetting} from '../models/all-events-setting';
import {BackendService} from './backend.service';

@Injectable()
export class RoomService {

  data: RoomSetting[] = [];

  constructor(private http: BackendService) { }

  getAllRooms(reload = false): Observable<RoomSetting[]> {
    if (!reload && this.data.length) {
      return Observable.create(observe => {
        observe.next(this.data);
        observe.complete();
      });
    }
    return Observable.create((subscriber) => {
      this.http.get('/api/data/room/getAllRooms').subscribe((res) => {
        const obj = Object.assign(new AllEventsSetting(), res);
        this.data = obj.data;
        subscriber.next(this.data);
        subscriber.complete();
      }, (error) => {
        subscriber.error(error);
      });
    });
  }

  postAddRoom(room: RoomSetting): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/room/addRoom`, JSON.stringify(room))
        .subscribe((res) => {
          observe.next(res);
          observe.complete();
      }, error => {
          observe.error(error);
        });
    });
  }

  deleteRoom(roomId: number): Observable<any> {
    return Observable.create((observe) => {
      this.http.delete(`/api/data/room/deleteRoom/${roomId}`).subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  putUpdateRoom(room: RoomSetting): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/room/updateRoom/${room.id}`, JSON.stringify(room)).subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  searchEmptyRooms(data): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/room/searchRooms`, JSON.stringify(data)).subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  setPeripheral(roomId: number, peripheral_flag: number): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/room/setPeripheral/${roomId}`, JSON.stringify({peripheral_flag: peripheral_flag}))
        .subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  setTypeRoom(data: any): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/room/setTypeRoom`, JSON.stringify(data))
        .subscribe((res) => {
          observe.next(res);
          observe.complete();
        }, error => {
          observe.error(error);
        });
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/room.service.ts